import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import get from 'lodash.get';
import FieldTitle from 'util/FieldTitle';

function DisabledInput({ force_value, label, record, resource, source, elStyle, choices }) {
    let value = force_value;
    if (!value && record) {
        value = get(record, source);
    }
    if (choices) {
        const valid_choice = choices.find((choice) => (choice.id === value));
        if (valid_choice) {
            value = valid_choice.name;
        }
    }

    return (
        <TextField
            value={value}
            floatingLabelText={<FieldTitle label={label} source={source} resource={resource} />}
            style={elStyle}
            disabled
        />
    );
}

DisabledInput.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    resource: PropTypes.string,
    source: PropTypes.string,
    elStyle: PropTypes.object,
};

export default DisabledInput;



// WEBPACK FOOTER //
// ./src/components/input/DisabledInput.js